import {Component, EventEmitter, Input, Output} from '@angular/core';
import {LanguageService} from '@app/service/language.service';
import {UserInfo} from '@app/model/user-info.model';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
	@Input() userInfo!: UserInfo | null;
	@Output() toggleSidenav = new EventEmitter();

	mobileMenuHidden = true;

	constructor(public languageService: LanguageService) {
	}

	toggleMobileMenu(): void {
		this.mobileMenuHidden = !this.mobileMenuHidden;
	}
}
